import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { canCreateWorkspace, useLicenseEntitlementLimit, useOrganizationEntitlement } from '#layers/access/public';

/**
 * Route-level backstop for the workspace-create page. The create button already guards, but the
 * page is directly reachable by URL/back-button, so a blocked user could bypass the button.
 * Redirect to the organization dashboard when the user lacks `workspace:create` (org-admin-gated)
 * or when workspaces are hard-blocked by the license. Soft limits stay reachable (creation is
 * still allowed). `workspaces` is an org entitlement, so enforce against org-wide usage regardless
 * of the active workspace.
 */
export default defineNuxtRouteMiddleware(async () => {
	const { can } = useOrganizationEntitlement();
	if (!can(canCreateWorkspace)) return '/~/organization/workspaces';

	const { isCreationBlocked } = useLicenseEntitlementLimit({ scope: 'system' });
	if (await isCreationBlocked('workspaces')) return '/~/organization/workspaces';
});
